import React from 'react';

const Template = (props) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='14'
      height='18'
      viewBox='0 0 14 18'
      fill='none'
      {...props}
    >
      <path
        d='M4.53111 13.4136H9.82778M4.53111 9.88247H9.82778M4.53111 6.35135H5.41389M8.06222 1.05469H3.82489C2.83609 1.05469 2.34168 1.05469 1.96401 1.24712C1.6318 1.41639 1.3617 1.68648 1.19244 2.0187C1 2.39637 1 2.89078 1 3.87958V14.1198C1 15.1086 1 15.603 1.19244 15.9807C1.3617 16.3129 1.6318 16.583 1.96401 16.7522C2.34168 16.9447 2.83609 16.9447 3.82489 16.9447H10.534C11.5228 16.9447 12.0172 16.9447 12.3949 16.7522C12.7271 16.583 12.9972 16.3129 13.1664 15.9807C13.3589 15.603 13.3589 15.1086 13.3589 14.1198V6.35135M8.06222 1.05469L13.3589 6.35135M8.06222 1.05469V4.93891C8.06222 5.43331 8.06222 5.68051 8.15844 5.86935C8.2431 6.03545 8.37808 6.1705 8.54422 6.25514C8.73304 6.35135 8.98022 6.35135 9.47467 6.35135H13.3589'
        stroke='currentColor'
        stroke-width='1.3'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
};

export default Template;
